module.exports = __webpack_public_path__ + "img/opportunities-underline.5f5aafe7.svg";